export enum OBRoutes {
  FormFields = '/form-structure/##practiceId/##formId',
  HourSlots = '/slot/##practiceId',
  AvailDays = '/slot/available-days/##practiceId',
  InitialConfig = '/practice/##practiceId/info',
  PaymentMethods = '/practice/##practiceId/paymentMethod',
  DoctorInfo = '/practice/##practiceId/doctorInfo',
  AppointmentTypes = '/appointment/##practiceId/appointmentType',
  ReservationSelection = '/v2/reservation/##practiceId',
  ReservationDeletion = '/reservation/##reservationId',
  ReservationRefresh = '/v2/reservation/##practiceId/##reservationId/refresh',
  InsuranceConfig = '/insurance/##organizationId',
  GeneralConfig = '/general-configurations/##practiceId',
  SchedulConfig = '/scheduling-configurations/##practiceId',
  IndividualDocConfig = '/doctor-configurations/##practiceId/##providerId',
  FormConfig = '/booking-form-configurations/##practiceId',
  CountryList = '/country/list',
  CountryStates = '/country/##countryCode/state',
  Appointment = '/appointment',
  AppointmentConfirm = '/appointment/##appointmentId/confirm',
  AppointmentDelete = '/appointment/##practiceId/##appointmentId/delete',
  MasterLookUpHolder = '/master-lookup/Holder/##organizationId',
  MasterLookUpGender = '/master-lookup/Gender/##organizationId',
  GalleryImages = '/practice/##practiceId/gallery',
}
